import React, { createContext, useContext, useEffect, useState } from "react";
import { initSeenBadges } from "../lib/store";

const AppContext = createContext(null);

export function AppProvider({ children }) {
  const [level, setLevelState] = useState(
    () => localStorage.getItem("hamprep_level") || "basic"
  );
  const [theme, setThemeState] = useState(
    () => localStorage.getItem("hamprep_theme") || "dark"
  );

  useEffect(() => {
    // Prépare le suivi des badges dès le démarrage (évite de masquer les badges d'un profil neuf).
    initSeenBadges("basic");
    initSeenBadges("advanced");
  }, []);

  useEffect(() => {
    const root = document.documentElement;
    if (theme === "dark") root.classList.add("dark");
    else root.classList.remove("dark");
    localStorage.setItem("hamprep_theme", theme);
  }, [theme]);

  const setLevel = (l) => {
    setLevelState(l);
    localStorage.setItem("hamprep_level", l);
  };
  const toggleTheme = () =>
    setThemeState((t) => (t === "dark" ? "light" : "dark"));

  return (
    <AppContext.Provider value={{ level, setLevel, theme, toggleTheme }}>
      {children}
    </AppContext.Provider>
  );
}

export const useApp = () => useContext(AppContext);
